import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import * as catalogueActions from '../../actions/catalogue';
import {
    catalogueStateKey,
    isCommonFilterDisabled,
    isCatalogueUpcoming,
} from '../../helpers/catalogueUtils';

class LotsFound extends PureComponent {
    static propTypes = {
        refinement: PropTypes.shape({
            lotNo: PropTypes.number,
            entered: PropTypes.bool,
            price: PropTypes.bool,
        }).isRequired,

        lotsFound: PropTypes.number.isRequired,

        applyCatalogueLotNoFilter: PropTypes.func.isRequired,
        applyCatalogueEnteredFilter: PropTypes.func.isRequired,
        applyCataloguePriceFilter: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            lotNo: props.refinement.lotNo
        };
        this.upcoming = isCatalogueUpcoming();

        this.handleLotNoChange = this.handleLotNoChange.bind(this);
        this.triggerLotNoChangeHandlerDebounced = debounce(
            this.triggerLotNoChangeHandler.bind(this),
            500
        );
        this.handleOnlyWithEntriesChange = this.handleOnlyWithEntriesChange.bind(this);
        this.handleOnlySoldChange = this.handleOnlySoldChange.bind(this);
    }

    componentWillReceiveProps({ refinement: { lotNo } }) {
        if (this.state.lotNo !== lotNo) {
            this.setState({ lotNo });
        }
    }

    triggerLotNoChangeHandler(lotNo) {
        this.props.applyCatalogueLotNoFilter(lotNo);
    }

    handleLotNoChange(e) {
        const lotNo = Number.parseInt(e.target.value, 10) || null;

        if (this.state.lotNo === lotNo) {
            return false;
        }

        this.setState({ lotNo });
        this.triggerLotNoChangeHandlerDebounced(lotNo);

        return true;
    }

    handleOnlyWithEntriesChange(e) {
        this.props.applyCatalogueEnteredFilter(e.target.checked);
    }

    handleOnlySoldChange(e) {
        this.props.applyCataloguePriceFilter(e.target.checked);
    }

    isCommonFilterDisabled() {
        return isCommonFilterDisabled(this.props.refinement);
    }

    renderCheckbox(id, label, checked, handleChange) {
        return (
            <div className="sales__catalogueRefineLotsEntriesWrp">
                <label htmlFor={id} className="checkbox_holder">
                    <input
                        type="checkbox"
                        id={id}
                        disabled={this.isCommonFilterDisabled()}
                        checked={checked}
                        onChange={handleChange}
                        className="ui-checkbox_input"
                    />
                    <span className="ui-checkbox" />
                    <span>{label}</span>
                </label>
            </div>
        );
    }

    renderOnlyEntriesCheckbox() {
        return this.renderCheckbox(
            'entries_only',
            'Show only lots with entries',
            this.props.refinement.entered,
            this.handleOnlyWithEntriesChange
        );
    }

    renderOnlySoldCheckbox() {
        return this.renderCheckbox(
            'sold_only',
            'Show only sold lots',
            this.props.refinement.price,
            this.handleOnlySoldChange
        );
    }

    render() {
        const { lotsFound } = this.props;
        return (
            <div className="sales__catalogueRefineLotsWrp">
                <div className="sales__catalogueRefineLotsNumWrp">
                    <span>Lots found</span>
                    <span
                        data-test-selector="lots_found_right_block"
                        className={classNames('sales__catalogueRefineLotsNumFound', {
                            sales__catalogueRefine_smLots: lotsFound.toString().length === 4,
                            sales__catalogueRefine_exSmLots: lotsFound.toString().length > 4,
                        })}
                    >
                        {lotsFound}
                    </span>
                </div>
                <input
                    type="number"
                    pattern="[0-9]+"
                    inputMode="numeric"
                    placeholder="Lot No."
                    className="ui-input"
                    value={this.state.lotNo || ''}
                    onChange={this.handleLotNoChange}
                />
                {this.upcoming ? this.renderOnlyEntriesCheckbox() : this.renderOnlySoldCheckbox()}
            </div>
        );
    }
}

function mapStateToProps({
    [catalogueStateKey]: {
        refinement,
        data: { lotsFound }
    },
}) {
    return {
        refinement,
        lotsFound,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(catalogueActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LotsFound);



// WEBPACK FOOTER //
// ./src/js/containers/Catalogue/LotsFound.js